export const navData = [
  {
    path: "/wallets",
    text: "kode.nav.wallets",
  },
  {
    path: "/ai-data",
    text: "kode.nav.aiData",
  },
  {
    path: "/case-studies",
    text: "kode.nav.caseStudies",
  },
  {
    path: "/company",
    text: "kode.nav.company",
  },
];
